import GroupSearchType from '../data/enum/GroupSearchType';
import { FIRST_POSTCODE_PART } from '../data/regexPatterns';

/**
 * Check if a value matches a search type (e.g. a postcode, outcode or a place)
 * Return the relevant enum
 * @returns string
 */
export const detectGroupSearchType = (value: string) => {
  const cleansedValue = value?.replace(' ', '');

  if (cleansedValue?.length <= 4 && FIRST_POSTCODE_PART.test(cleansedValue)) {
    return GroupSearchType.OUTCODE;
  }

  if (cleansedValue?.length > 2) {
    if (/\d/.test(cleansedValue)) {
      return GroupSearchType.POSTCODE;
    }
    return GroupSearchType.PLACE;
  }

  return GroupSearchType.UNKNOWN;
};
